'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$10() {
  this.b9Q = null;
  this.b9R = false;
}
export { $c_Lpresto_Presto$$anon$10 as $c_Lpresto_Presto$$anon$10 };
$p = $c_Lpresto_Presto$$anon$10.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$10;
/** @constructor */
function $h_Lpresto_Presto$$anon$10() {
}
export { $h_Lpresto_Presto$$anon$10 as $h_Lpresto_Presto$$anon$10 };
$h_Lpresto_Presto$$anon$10.prototype = $p;
$p.P = (function() {
  if ((!this.b9R)) {
    this.b9Q = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$()));
    this.b9R = true;
  }
  return this.b9Q;
});
var $d_Lpresto_Presto$$anon$10 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$10, "presto.Presto$$anon$10", ({
  Nf: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_Presto$$anon$10 as $d_Lpresto_Presto$$anon$10 };
//# sourceMappingURL=presto.-Presto$$anon$10.js.map
